// =========================================
// COMPLETE FIXED JAVASCRIPT - PRICES IN UNITS (NOT CENTS)
// =========================================

// Mobile detection helper - MUST be defined first, before any functions that use it
// Defined early to ensure availability on page load
if (typeof window.isMobileDevice !== 'function') {
    window.isMobileDevice = function() {
        return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
}

// Global variables - declared once
window.currentOpenDrawerId = null;
window.paymentStates = {};
window.videoModal = null;
window.paymentCalcModal = null;

// Currency formatting function
// amount is in USD UNITS by default (e.g. 99750 = $99,750)
window.formatCurrency = function(amount, isCents = false) {
    let usdAmount = isCents ? amount / 100 : amount;

    if (window.localeInfo && window.localeInfo.isCanada) {
        const cadAmount = usdAmount * (window.localeInfo.currencyRate || 1.40);
        return `C$ ${cadAmount.toLocaleString('en-CA', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    } else {
        return `$${usdAmount.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
};

// Payment state management
// All amounts stored as USD UNITS
window.getPaymentState = function(productId) {
    const key = productId.toString();
    if (!window.paymentStates[key]) {
        window.paymentStates[key] = {
            currentPlotPrice: 0,   // USD units (e.g. 99750 = $99,750)
            currentDeposit: null,  // USD units
            currentTermMonths: null,
            currentTermLabel: '',
            isFullPayment: false,
            reservationFee: 250,   // USD units
            currentMonthlyPayment: 0, // USD units
            availableDeposits: [],
            availableTermMonths: []
        };
    }
    return window.paymentStates[key];
};

window.parseOasisMoneyValue = function(value) {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }

    var normalized = String(value).trim();
    if (!normalized || normalized === 'null' || normalized === 'undefined') return null;

    var lowered = normalized.toLowerCase();
    if (lowered === 'full' || lowered === 'full payment') return 'full';
    if (lowered === 'no deposit' || lowered === 'none' || lowered === 'zero') return 0;

    var sanitized = lowered
        .replace(/usd|cad/g, '')
        .replace(/c\$/g, '')
        .replace(/\$/g, '')
        .replace(/,/g, '')
        .replace(/[^0-9.-]/g, '');

    if (!sanitized || sanitized === '-' || sanitized === '.' || sanitized === '-.') return null;

    var parsed = Number(sanitized);
    return Number.isFinite(parsed) ? parsed : null;
};

window.parseOasisOptionSource = function(source) {
    if (source === null || source === undefined || source === '') return [];

    var parsed = source;
    if (typeof parsed === 'string') {
        var trimmed = parsed.trim();
        if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return [];

        try {
            parsed = JSON.parse(trimmed);
        } catch (error) {
            parsed = trimmed;
        }
    }

    if (Array.isArray(parsed)) return parsed;

    if (typeof parsed === 'string') {
        return parsed
            .split(/[\n,;|]/)
            .map(function(item) { return item.trim(); })
            .filter(Boolean);
    }

    return [parsed];
};

window.normalizeTermMonths = function(value) {
    if (value === null || value === undefined || value === '') return null;

    var normalized = String(value).trim();
    if (!normalized || normalized === 'null' || normalized === 'undefined') return null;

    var parsed = Number(normalized.replace(/[^0-9.-]/g, ''));
    if (!Number.isFinite(parsed) || parsed <= 0) return null;

    if (/month/i.test(normalized) || parsed > 10) {
        return Math.round(parsed);
    }

    return Math.round(parsed * 12);
};

window.buildTermOptionLabel = function(months) {
    var years = Math.round(months / 12);
    return years + ' year' + (years === 1 ? '' : 's') + ' (' + months + ' months, 0% interest)';
};

window.buildShortTermLabel = function(months) {
    var years = Math.round(months / 12);
    return years + ' Year' + (years === 1 ? '' : 's');
};

window.LEGACY_PRODUCT_TERMS = {
    10221313786122: [96, 84],
    10285268369674: [96, 84],
    default: [72, 60, 48, 36, 24, 12]
};

// Approved default term: the value configured on the reservation form
// (last payment_term_years value x 12) when it is available, otherwise the
// longest configured term. Never silently prefer 72 months (F05/F22).
window.resolveDefaultTermMonths = function(sourceForm, terms) {
    var configured = window.normalizeTermMonths(sourceForm && sourceForm.dataset ? sourceForm.dataset.oasisDefaultTerm : '');
    var list = Array.isArray(terms) ? terms : [];
    if (configured && (!list.length || list.indexOf(configured) !== -1)) return configured;
    if (list.length) return list[0];
    return configured || 72;
};

window.getPrimaryPaymentForm = function(productId) {
    return document.querySelector('.oasis-reserve-form-v2[data-product-id="' + productId + '"]')
        || document.querySelector('.modal-reservation-form[data-product-id="' + productId + '"]');
};

window.copyReservationConfig = function(sourceForm, targetForm) {
    if (!sourceForm || !targetForm) return;

    [
        'productId',
        'oasisPlotPrice',
        'oasisReservationFee',
        'oasisDefaultDeposit',
        'oasisDefaultTerm',
        'oasisTermOptions',
        'oasisDepositOptions'
    ].forEach(function(key) {
        if (sourceForm.dataset[key] !== undefined) {
            targetForm.dataset[key] = sourceForm.dataset[key];
        }
    });
};

window.getConfiguredTermMonths = function(productId, sourceForm) {
    var productKey = String(productId);
    var configured = window.parseOasisOptionSource(sourceForm && sourceForm.dataset ? sourceForm.dataset.oasisTermOptions : '');
    var seen = new Set();
    var months = [];

    configured.forEach(function(option) {
        var normalized = window.normalizeTermMonths(option);
        if (!normalized || normalized < 12 || normalized > 120) return;

        var key = String(normalized);
        if (seen.has(key)) return;
        seen.add(key);
        months.push(normalized);
    });

    if (!months.length) {
        months = (window.LEGACY_PRODUCT_TERMS[productKey] || window.LEGACY_PRODUCT_TERMS.default || [72, 60, 48, 36, 24, 12]).slice();
    }

    return months.sort(function(a, b) { return b - a; });
};

window.getConfiguredDepositOptions = function(sourceForm) {
    var configured = window.parseOasisOptionSource(sourceForm && sourceForm.dataset ? sourceForm.dataset.oasisDepositOptions : '');
    var seen = new Set();
    var deposits = [];

    configured.forEach(function(option) {
        var normalized = window.parseOasisMoneyValue(option);
        if (normalized === null || normalized === 'full' || normalized < 0) return;

        var key = String(Number(normalized));
        if (seen.has(key)) return;
        seen.add(key);
        deposits.push(Number(normalized));
    });

    if (!deposits.length) {
        var fallback = [];
        var defaultDeposit = window.parseOasisMoneyValue(sourceForm && sourceForm.dataset ? sourceForm.dataset.oasisDefaultDeposit : '');

        if (defaultDeposit !== null && defaultDeposit !== 'full' && defaultDeposit >= 0) {
            fallback.push(Number(defaultDeposit));
        }

        [10000, 20000].forEach(function(amount) {
            if (fallback.indexOf(amount) === -1) fallback.push(amount);
        });

        deposits = fallback;
    }

    return deposits;
};

window.formatDepositOptionLabel = function(amount) {
    return Number(amount) === 0 ? 'No Deposit' : window.formatCurrency(amount);
};

window.ensureReservationFormInputs = function(form) {
    if (!form) return;

    [
        ['deposit', 'properties[_oasis_selected_deposit]'],
        ['term-months', 'properties[_oasis_selected_term_months]'],
        ['term-label', 'properties[_oasis_selected_term_label]'],
        ['monthly-payment', 'properties[_oasis_selected_monthly_payment]'],
        ['payment-mode', 'properties[_oasis_payment_mode]'],
        ['lot-price', 'properties[_oasis_lot_price]'],
        ['reservation-fee', 'properties[_oasis_reservation_fee]']
    ].forEach(function(fieldConfig) {
        var key = fieldConfig[0];
        var inputName = fieldConfig[1];
        var input = form.querySelector('[data-oasis-property="' + key + '"]');

        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = inputName;
            input.setAttribute('data-oasis-property', key);
            form.appendChild(input);
        }
    });
};

window.getReservationForms = function(productId) {
    var forms = [];
    var seen = new Set();
    var addForm = function(form) {
        if (!form || seen.has(form)) return;
        seen.add(form);
        forms.push(form);
    };

    var modal = window.paymentCalcModal || document.getElementById('paymentCalcModal');
    if (modal) {
        addForm(modal.querySelector('.modal-reservation-form'));
    }

    document.querySelectorAll('.oasis-reserve-form-v2[data-product-id="' + productId + '"]').forEach(addForm);
    document.querySelectorAll('.modal-reservation-form[data-product-id="' + productId + '"]').forEach(addForm);

    return forms;
};

window.ensurePaymentStateDefaults = function(productId, sourceForm) {
    var paymentState = window.getPaymentState(productId);
    var form = sourceForm || window.getPrimaryPaymentForm(String(productId)) || null;
    var parseValue = function(value, fallback) {
        var parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
    };
    var availableTerms = window.getConfiguredTermMonths(productId, form);
    var availableDeposits = window.getConfiguredDepositOptions(form);
    var defaultTerm = window.resolveDefaultTermMonths(form, availableTerms);
    var defaultDeposit = window.parseOasisMoneyValue(form && form.dataset ? form.dataset.oasisDefaultDeposit : '');

    if (defaultDeposit === null || defaultDeposit === 'full' || defaultDeposit < 0) {
        defaultDeposit = availableDeposits.length ? availableDeposits[0] : 0;
    }

    // The initial deposit must be one of the approved options for this lot (F22).
    if (availableDeposits.length && availableDeposits.indexOf(Number(defaultDeposit)) === -1) {
        defaultDeposit = availableDeposits[0];
    }

    paymentState.currentPlotPrice = parseValue(
        form && form.dataset ? form.dataset.oasisPlotPrice : '',
        paymentState.currentPlotPrice
    );
    paymentState.reservationFee = parseValue(
        form && form.dataset ? form.dataset.oasisReservationFee : '',
        paymentState.reservationFee || 250
    );
    paymentState.availableTermMonths = availableTerms.slice();
    paymentState.availableDeposits = availableDeposits.slice();

    if (paymentState.isFullPayment) {
        paymentState.currentDeposit = Math.max(paymentState.currentPlotPrice - paymentState.reservationFee, 0);
        paymentState.currentTermMonths = 0;
        paymentState.currentTermLabel = 'Full payment';
        paymentState.currentMonthlyPayment = 0;
        return paymentState;
    }

    var hasCurrentDeposit = paymentState.currentDeposit !== null
        && paymentState.currentDeposit !== undefined
        && paymentState.currentDeposit !== '';
    var currentDeposit = hasCurrentDeposit ? Number(paymentState.currentDeposit) : NaN;
    var depositIsConfigured = Number.isFinite(currentDeposit)
        && availableDeposits.indexOf(currentDeposit) !== -1;

    if (!depositIsConfigured) {
        paymentState.currentDeposit = Number(defaultDeposit);
    }

    if (!paymentState.currentTermMonths || paymentState.currentTermMonths <= 0) {
        paymentState.currentTermMonths = defaultTerm;
    } else if (availableTerms.length && availableTerms.indexOf(paymentState.currentTermMonths) === -1) {
        paymentState.currentTermMonths = availableTerms[0];
    }

    paymentState.currentTermLabel = window.buildTermOptionLabel(paymentState.currentTermMonths);
    paymentState.currentMonthlyPayment = window.calculateMonthly(productId, paymentState.currentTermMonths);
    return paymentState;
};

window.renderDepositButtons = function(productId) {
    var modal = window.paymentCalcModal || document.getElementById('paymentCalcModal');
    if (!modal) return;

    var container = modal.querySelector('.deposit-buttons');
    if (!container) return;

    var sourceForm = window.getPrimaryPaymentForm(String(productId)) || modal.querySelector('.modal-reservation-form');
    var paymentState = window.ensurePaymentStateDefaults(productId, sourceForm);
    var deposits = paymentState.availableDeposits && paymentState.availableDeposits.length
        ? paymentState.availableDeposits
        : window.getConfiguredDepositOptions(sourceForm);

    container.innerHTML = '';

    deposits.forEach(function(amount) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'deposit-btn';
        button.setAttribute('data-oasis-deposit-option', String(amount));
        button.textContent = window.formatDepositOptionLabel(amount);
        button.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            window.updateDeposit(amount, button);
        });
        container.appendChild(button);
    });

    var fullButton = document.createElement('button');
    fullButton.type = 'button';
    fullButton.className = 'deposit-btn deposit-btn--full';
    fullButton.setAttribute('data-oasis-deposit-option', 'full');
    fullButton.textContent = 'Full Payment';
    fullButton.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        window.updateDeposit('full', fullButton);
    });
    container.appendChild(fullButton);

    window.syncDepositButtons(productId);
};

window.syncDepositButtons = function(productId) {
    var modal = window.paymentCalcModal || document.getElementById('paymentCalcModal');
    if (!modal) return;

    var paymentState = window.getPaymentState(productId);
    modal.querySelectorAll('.deposit-buttons .deposit-btn').forEach(function(btn) {
        var option = btn.getAttribute('data-oasis-deposit-option');
        var matches = false;

        btn.classList.remove('active');

        if (paymentState.isFullPayment) {
            matches = option === 'full';
        } else if (option && option !== 'full') {
            matches = Number(option) === Number(paymentState.currentDeposit || 0);
        }

        if (matches) {
            btn.classList.add('active');
        }
    });
};

// =========================================
// PAYMENT CALCULATOR FUNCTIONS
// =========================================

window.openPaymentCalculator = function(price, title, productId, variantId) {
    window.OasisDebug && console.log('Opening payment calculator for:', productId, title, 'raw price:', price);

    // Ensure modal reference exists
    if (!window.paymentCalcModal) {
        window.paymentCalcModal = document.getElementById('paymentCalcModal');
    }

    if (!window.paymentCalcModal) {
        console.error('Payment calculator modal not found!');
        return;
    }

    // Normalize price
    var priceUnits;
    if (price > 1000000) {
        priceUnits = price / 100;
    } else {
        priceUnits = price;
    }

    // Store current product info
    window.paymentCalcModal.dataset.currentProductId = productId;

    var modalForm = window.paymentCalcModal.querySelector('.modal-reservation-form');
    var sourceForm = window.getPrimaryPaymentForm(String(productId));
    if (modalForm) {
        modalForm.dataset.productId = String(productId);
        if (sourceForm) {
            window.copyReservationConfig(sourceForm, modalForm);
        }
        modalForm.dataset.oasisPlotPrice = String(priceUnits);
        window.ensureReservationFormInputs(modalForm);
    }

    // Set the correct variant ID on the checkout form
    var variantInput = window.paymentCalcModal.querySelector('.modal-reservation-form input[name="id"]');
    if (variantInput && variantId) {
        variantInput.value = variantId;
    }

    // Update modal content
    var titleElement = document.getElementById('calc-product-title');
    var priceElement = document.getElementById('calc-total-price');

    if (titleElement) titleElement.textContent = title;
    if (priceElement) priceElement.textContent = window.formatCurrency(priceUnits);

    // Initialize calculator state
    var paymentState = window.getPaymentState(productId);
    paymentState.currentPlotPrice = priceUnits;
    window.ensurePaymentStateDefaults(productId, sourceForm || modalForm);

    // Ensure reserve button is interactable when modal opens
    var reserveBtn = window.paymentCalcModal.querySelector('.js-reserve-btn');
    if (reserveBtn) {
        reserveBtn.disabled = false;
        reserveBtn.style.opacity = '1';
        reserveBtn.style.cursor = 'pointer';
    }

    // Show modal
    window.paymentCalcModal.style.display = 'flex';
    // Only lock scroll on mobile devices
    if (window.isMobileDevice()) {
        document.body.style.overflow = 'hidden';
    }

    // Initialize calculator
    window.renderDepositButtons(productId);
    window.renderCalculatorTerms(productId);
    window.updateCalculatorSummary(productId);
    window.syncReservationForm(productId);
};

window.closePaymentCalculator = function() {
    if (window.paymentCalcModal) {
        window.paymentCalcModal.style.display = 'none';
        // Only unlock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = '';
        }
    }
};

if (Array.isArray(window._oasisPendingPaymentCalculator)) {
    const pendingPaymentCalculatorArgs = window._oasisPendingPaymentCalculator;
    window._oasisPendingPaymentCalculator = null;
    setTimeout(function() {
        window.openPaymentCalculator.apply(window, pendingPaymentCalculatorArgs);
    }, 0);
}

window.updateDeposit = function(amount, btnElement) {
    const productId = window.paymentCalcModal?.dataset.currentProductId;
    if (!productId) return;

    const paymentState = window.getPaymentState(productId);
    const sourceForm = window.getPrimaryPaymentForm(String(productId))
        || (window.paymentCalcModal || document.getElementById('paymentCalcModal'))?.querySelector('.modal-reservation-form');
    const availableTerms = window.getConfiguredTermMonths(productId, sourceForm);

    // Reset active state
    window.paymentCalcModal.querySelectorAll('.deposit-btn').forEach(btn => btn.classList.remove('active'));
    if (btnElement) btnElement.classList.add('active');

    if (amount === 'full') {
        paymentState.isFullPayment = true;
        // Pay everything except reservation fee up front
        paymentState.currentDeposit = paymentState.currentPlotPrice - paymentState.reservationFee;
        if (paymentState.currentDeposit < 0) paymentState.currentDeposit = 0;
        paymentState.currentTermMonths = 0;
        paymentState.currentTermLabel = 'Full payment';
    } else {
        paymentState.isFullPayment = false;
        // amount is in USD units (0, 10000, 20000, ...)
        paymentState.currentDeposit = amount;
        if (paymentState.currentTermMonths === 0 || !paymentState.currentTermMonths) {
            paymentState.currentTermMonths = window.resolveDefaultTermMonths(sourceForm, availableTerms);
        }
        paymentState.currentTermLabel = window.buildTermOptionLabel(paymentState.currentTermMonths);
    }

    window.renderCalculatorTerms(productId);
    window.updateCalculatorSummary(productId);
};

window.selectTerm = function(months) {
    const productId = window.paymentCalcModal?.dataset.currentProductId;
    if (!productId) return;

    const paymentState = window.getPaymentState(productId);
    const termSelect = (window.paymentCalcModal || document.getElementById('paymentCalcModal'))?.querySelector('.term-select');

    paymentState.currentTermMonths = months;
    paymentState.currentTermLabel = (
        termSelect && termSelect.options && termSelect.selectedIndex >= 0
            ? termSelect.options[termSelect.selectedIndex].text
            : window.buildTermOptionLabel(months)
    );
    paymentState.currentMonthlyPayment = window.calculateMonthly(productId, months);
    window.updateCalculatorSummary(productId);
};

window.calculateMonthly = function(productId, months) {
    const paymentState = window.getPaymentState(productId);
    if (months === 0) return 0;

    // All in units
    let principal = paymentState.currentPlotPrice - paymentState.currentDeposit - paymentState.reservationFee;
    if (principal < 0) principal = 0;

    return principal / months;
};

window.renderCalculatorTerms = function(productId) {
  const container = document.getElementById('term-list-container');
  if (!container) return;

  const paymentState = window.getPaymentState(productId);
  const sourceForm = window.getPrimaryPaymentForm(String(productId))
    || (window.paymentCalcModal || document.getElementById('paymentCalcModal'))?.querySelector('.modal-reservation-form');
  container.innerHTML = '';

  if (paymentState.isFullPayment) {
    container.innerHTML = '<div class="term-list-message">No monthly payments required. Balance paid in full.</div>';
    return;
  }

  const terms = window.getConfiguredTermMonths(productId, sourceForm);

  if (!paymentState.currentTermMonths || terms.indexOf(paymentState.currentTermMonths) === -1) {
    paymentState.currentTermMonths = window.resolveDefaultTermMonths(sourceForm, terms);
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'term-select-wrap';

  const selectEl = document.createElement('select');
  selectEl.className = 'term-select';

  terms
    .slice()
    .sort((a, b) => b - a)
    .forEach(months => {
      var opt = document.createElement('option');
      opt.value = String(months);
      opt.textContent = window.buildTermOptionLabel(months);
      if (months === paymentState.currentTermMonths) opt.selected = true;
      selectEl.appendChild(opt);
    });

  selectEl.addEventListener('change', function(e) {
    e.stopPropagation();
    var months = parseInt(this.value, 10);
    window.selectTerm(months);
  });

  wrapper.appendChild(selectEl);
  container.appendChild(wrapper);

  window.selectTerm(paymentState.currentTermMonths);
};

window.syncReservationForm = function(productId) {
    const forms = window.getReservationForms(String(productId));
    if (!forms.length) return;

    const paymentState = window.ensurePaymentStateDefaults(productId, forms[0]);
    const termMonths = paymentState.isFullPayment ? 0 : Number(paymentState.currentTermMonths || 0);
    const monthlyPayment = paymentState.isFullPayment || termMonths <= 0
        ? 0
        : window.calculateMonthly(productId, termMonths);
    const roundedYears = termMonths > 0 ? Math.round(termMonths / 12) : 0;
    const termSelect = (window.paymentCalcModal || document.getElementById('paymentCalcModal'))?.querySelector('.term-select');
    const termLabel = paymentState.isFullPayment
        ? 'Full payment'
        : (
            paymentState.currentTermLabel
                ? paymentState.currentTermLabel
                : termSelect && termSelect.options && termSelect.selectedIndex >= 0
                ? termSelect.options[termSelect.selectedIndex].text
                : window.buildTermOptionLabel(termMonths || (roundedYears * 12))
        );

    forms.forEach(function(form) {
        window.ensureReservationFormInputs(form);
        form.dataset.productId = String(productId);
        form.dataset.oasisPlotPrice = String(Number(paymentState.currentPlotPrice || 0));
        form.dataset.oasisReservationFee = String(Number(paymentState.reservationFee || 250));

        const setValue = function(selector, value) {
            const field = form.querySelector(selector);
            if (field) field.value = value;
        };

        setValue('[data-oasis-property="deposit"]', Number(paymentState.currentDeposit || 0).toFixed(2));
        setValue('[data-oasis-property="term-months"]', String(termMonths));
        setValue('[data-oasis-property="term-label"]', termLabel);
        setValue('[data-oasis-property="monthly-payment"]', Number(monthlyPayment || 0).toFixed(2));
        setValue('[data-oasis-property="payment-mode"]', paymentState.isFullPayment ? 'full' : 'finance');
        setValue('[data-oasis-property="lot-price"]', Number(paymentState.currentPlotPrice || 0).toFixed(2));
        setValue('[data-oasis-property="reservation-fee"]', Number(paymentState.reservationFee || 250).toFixed(2));
    });
};

window.trackReservationAddToCart = function(productId, form) {
    if (typeof window.oasisTrackMeta !== 'function') return;

    const paymentState = window.getPaymentState(productId);
    const reservationFee = Number(
        paymentState.reservationFee
        || (form && form.dataset ? form.dataset.oasisReservationFee : 250)
        || 250
    );
    const variantId = form && form.querySelector ? form.querySelector('input[name="id"]')?.value : '';
    const payload = {
        currency: 'USD',
        value: reservationFee,
        content_type: 'product'
    };

    if (variantId) {
        payload.content_ids = [String(variantId)];
    }

    window.oasisTrackMeta('AddToCart', payload);
};

window.bindReservationForms = function() {
    document.querySelectorAll('.modal-reservation-form, .oasis-reserve-form-v2').forEach(function(form) {
        if (form.dataset.oasisSyncBound === 'true') return;

        form.dataset.oasisSyncBound = 'true';
        window.ensureReservationFormInputs(form);

        form.addEventListener('submit', function() {
            var productId = this.dataset.productId || window.paymentCalcModal?.dataset.currentProductId;
            if (!productId) return;

            try {
                sessionStorage.setItem('oasis_session_cart_cleared', '1');
            } catch (error) {}

            window.ensurePaymentStateDefaults(productId, this);
            window.syncReservationForm(productId);
            window.trackReservationAddToCart(productId, this);
        });
    });
};



window.updateCalculatorSummary = function(productId) {
    const paymentState = window.getPaymentState(productId);

    const depositRow = document.getElementById('summary-deposit-row');
    const depositElement = document.getElementById('summary-deposit');
    const monthlyElement = document.getElementById('summary-monthly');
    const totalElement = document.getElementById('summary-total-payable');

    if (depositRow) {
        depositRow.style.display = paymentState.isFullPayment ? 'none' : '';
    }

    if (depositElement) {
        depositElement.textContent = window.formatCurrency(paymentState.currentDeposit);
    }

    let monthly = 0;
    if (!paymentState.isFullPayment && paymentState.currentTermMonths > 0) {
        monthly = window.calculateMonthly(productId, paymentState.currentTermMonths);
    }

    if (monthlyElement) {
        monthlyElement.textContent = window.formatCurrency(monthly);
    }

    if (totalElement) {
        totalElement.textContent = window.formatCurrency(paymentState.currentPlotPrice);
    }

    paymentState.currentMonthlyPayment = monthly;
    window.syncProductPaymentDisplays(productId);
    window.syncReservationForm(productId);
};

window.syncProductPaymentDisplays = function(productId) {
    const paymentState = window.getPaymentState(productId);
    const monthlyAmount = paymentState.isFullPayment ? 0 : Number(paymentState.currentMonthlyPayment || 0);
    const termLabel = paymentState.isFullPayment
        ? 'Full Payment'
        : window.buildShortTermLabel(paymentState.currentTermMonths || 72);

    window.updateMonthlyDisplay(productId, monthlyAmount);

    document
        .querySelectorAll('[data-oasis-term-display][data-product-id="' + productId + '"]')
        .forEach(function(element) {
            element.textContent = termLabel;
        });
};

window.updateMonthlyDisplay = function(productId, monthlyAmount) {
    // Update the specific product's monthly display in the collection
    const productCards = document.querySelectorAll(`[data-product-id="${productId}"]`);
    productCards.forEach(card => {
        const monthlyDisplay = card.querySelector('.trigger-value .money');
        if (monthlyDisplay) {
            monthlyDisplay.textContent = window.formatCurrency(monthlyAmount);
        }
    });

    document
        .querySelectorAll('[data-oasis-monthly-display][data-product-id="' + productId + '"]')
        .forEach(function(element) {
            element.textContent = window.formatCurrency(monthlyAmount);
        });

    // Also update in the drawer if this product's drawer is open
    const drawer = document.getElementById(`product-drawer-${productId}`);
    if (drawer && drawer.classList.contains('open')) {
        const drawerMonthly = drawer.querySelector('#display-monthly');
        if (drawerMonthly) {
            drawerMonthly.textContent = window.formatCurrency(monthlyAmount);
        }
    }
};

window.initializeProductPaymentDisplays = function() {
    document.querySelectorAll('.oasis-reserve-form-v2[data-product-id]').forEach(function(form) {
        var productId = form.dataset.productId;
        if (!productId) return;

        window.ensurePaymentStateDefaults(productId, form);
        window.updateCalculatorSummary(productId);
    });
};

window.bindReservationForms();
window.initializeProductPaymentDisplays();

// =========================================
// VIDEO MODAL FUNCTIONS
// =========================================

window.toggleVideoMenu = function(btn) {
    const container = btn.parentElement;
    container.classList.toggle('open');
};

window.openVideoModal = function(url) {
    if (!window.videoModal) {
        window.videoModal = document.getElementById('videoModal');
    }

    if (!window.videoModal) {
        console.error('Video modal not found!');
        return;
    }

    const iframe = document.getElementById('main-video-iframe');
    if (iframe) {
        // QC D11: the modal iframe ships without a src (data-src holds the embed URL) so the
        // hidden player is not downloaded at page load; hydrate it here, on open.
        if (url) {
            iframe.src = url + "?autoplay=1";
        } else if (iframe.getAttribute('data-src')) {
            iframe.src = iframe.getAttribute('data-src');
        }
    }
    window.videoModal.style.display = 'flex';
    // Only lock scroll on mobile devices
    if (window.isMobileDevice()) {
        document.body.style.overflow = 'hidden';
    }
};

window.closeVideoModal = function() {
    if (window.videoModal) {
        const iframe = document.getElementById('main-video-iframe');
        if (iframe) {
            iframe.src = "";
        }
        window.videoModal.style.display = 'none';
        // Only unlock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = '';
        }
    }
};


// =========================================
// DRAWER FUNCTIONS
// =========================================

window.openDrawer = function(productId, event) {
    try {
        // Prevent default if event provided
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        // Prevent multiple rapid calls
        if (window._drawerOpening) return;
        window._drawerOpening = true;
        
        // Validate productId
        if (!productId) {
            console.error('openDrawer: productId is required');
            window._drawerOpening = false;
            return;
        }
        
        // Close any previously open drawer
        if (window.currentOpenDrawerId && window.currentOpenDrawerId !== productId) {
            window.closeDrawer(window.currentOpenDrawerId);
        }
        
        const drawer = document.getElementById('product-drawer-' + productId);
        const overlay = document.getElementById('drawer-overlay-' + productId);
        
        // Check if drawer exists
        if (!drawer) {
            console.error('openDrawer: Drawer not found for productId:', productId);
            window._drawerOpening = false;
            return;
        }
        
        // Save current scroll position
        const scrollY = window.scrollY || window.pageYOffset || 0;
        
        // Add drawer-open class to body
        document.body.classList.add('drawer-open');
        
        // CRITICAL: Prevent background page scrolling on mobile only
        if (window.isMobileDevice && window.isMobileDevice()) {
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = `-${scrollY}px`;
            document.body.setAttribute('data-scroll-y', scrollY.toString());
        }

        // Show drawer and overlay
        drawer.classList.add('open');
        if (overlay) overlay.classList.add('open');

        // Set current open drawer
        window.currentOpenDrawerId = productId;

        // Use requestAnimationFrame for smooth initialization
        requestAnimationFrame(() => {
            try {
                // Init gallery slides for this product (if function exists)
                if (typeof window.initDrawerGallery === 'function') {
                    window.initDrawerGallery(productId);
                }
                
                // Initialize drawer navigation and scroll spy (if function exists)
                if (typeof window.initDrawerNavigation === 'function') {
                    window.initDrawerNavigation(productId);
                }
                
                // Reset to top after a short delay
                setTimeout(() => {
                    const panelBody = drawer.querySelector('.panel-body');
                    if (panelBody) {
                        panelBody.scrollTop = 0;
                    }
                    window._drawerOpening = false;
                }, 100);
            } catch (err) {
                console.error('Error initializing drawer content:', err);
                window._drawerOpening = false;
            }
        });
    } catch (error) {
        console.error('Error in openDrawer:', error);
        window._drawerOpening = false;
    }
};

window.closeDrawer = function(productId, event) {
    try {
        // Prevent default if event provided
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        // Prevent multiple rapid calls
        if (window._drawerClosing) return;
        window._drawerClosing = true;
        
        // Validate productId
        if (!productId) {
            console.error('closeDrawer: productId is required');
            window._drawerClosing = false;
            return;
        }
        
        const drawer = document.getElementById('product-drawer-' + productId);
        const overlay = document.getElementById('drawer-overlay-' + productId);
        
        // Hide drawer and overlay
        if (drawer) drawer.classList.remove('open');
        if (overlay) overlay.classList.remove('open');
        
        // Remove drawer-open class from body
        document.body.classList.remove('drawer-open');
        
        // Restore scroll position on mobile devices
        if (window.isMobileDevice && window.isMobileDevice()) {
            const scrollY = document.body.getAttribute('data-scroll-y') || '0';
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';
            document.body.removeAttribute('data-scroll-y');
            
            // Restore scroll position after a short delay
            requestAnimationFrame(() => {
                window.scrollTo(0, parseInt(scrollY, 10) || 0);
            });
        }
        
        // Stop scroll spy observer
        if (window.scrollSpyObserver) {
            try {
                window.scrollSpyObserver.disconnect();
            } catch (e) {
                // Observer might already be disconnected
            }
            window.scrollSpyObserver = null;
        }
        
        // Clear current open drawer
        if (window.currentOpenDrawerId === productId) {
            window.currentOpenDrawerId = null;
        }
        
        // Reset closing flag after animation
        setTimeout(() => {
            window._drawerClosing = false;
        }, 300);
    } catch (error) {
        console.error('Error in closeDrawer:', error);
        window._drawerClosing = false;
    }
};

window.initDrawerNavigation = function(productId) {
    try {
        const drawer = document.getElementById('product-drawer-' + productId);
        if (!drawer) return;
        
        // Reset all nav links to inactive
        const navLinks = drawer.querySelectorAll('.nav-link');
        navLinks.forEach(link => link.classList.remove('active'));
        
        // Set first nav link as active initially
        if (navLinks.length > 0) {
            navLinks[0].classList.add('active');
        }
        
        // Initialize scroll spy for this drawer (if function exists)
        if (typeof window.initScrollSpy === 'function') {
            // Defer scroll spy initialization to avoid blocking
            requestAnimationFrame(() => {
                try {
                    window.initScrollSpy(productId);
                } catch (err) {
                    console.error('Error initializing scroll spy:', err);
                }
            });
        }
    } catch (error) {
        console.error('Error initializing drawer navigation:', error);
    }
};

window.scrollToSectionInDrawer = function(productId, sectionType) {
    try {
        const drawer = document.getElementById('product-drawer-' + productId);
        if (!drawer) return;
    
    // Map section types to their data attributes
    const sectionSelectors = {
        'specs': '[data-section="specs"]',
        'desc': '[data-section="desc"]',
        'payment': '[data-section="payment"]',
        'included': '[data-section="included"]',
        'location': '[data-section="location"]',
        'concepts': '[data-section="concepts"]'
    };
    
    const targetSelector = sectionSelectors[sectionType];
    if (!targetSelector) return;
    
    // Find the section by data attribute
    const targetSection = drawer.querySelector(targetSelector);
    
    if (targetSection) {
        // Calculate offset for fixed header
        const headerHeight = drawer.querySelector('.panel-header-wrapper')?.offsetHeight || 0;
        const sectionTop = targetSection.offsetTop - headerHeight - 20;
        
        // Smooth scroll to section
        const panelBody = drawer.querySelector('.panel-body');
        if (panelBody) {
            panelBody.scrollTo({
                top: sectionTop,
                behavior: 'smooth'
            });
        }
        
        // Temporarily disable scroll spy to prevent conflict
        if (window.scrollSpyObserver) {
            window.scrollSpyObserver.disconnect();
        }
        
        // Update active nav link after a short delay
        setTimeout(() => {
            if (typeof window.updateActiveNavLink === 'function') {
                window.updateActiveNavLink(productId, sectionType);
            }
            
            // Re-enable scroll spy
            if (typeof window.initScrollSpy === 'function') {
                window.initScrollSpy(productId);
            }
        }, 1000);
    }
    } catch (error) {
        console.error('Error scrolling to section:', error);
    }
};

window.initScrollSpy = function(productId) {
    const drawer = document.getElementById('product-drawer-' + productId);
    if (!drawer) return;
    
    const panelBody = drawer.querySelector('.panel-body');
    const sections = drawer.querySelectorAll('.content-section[data-section]');
    const navLinks = drawer.querySelectorAll('.nav-link');
    
    if (!panelBody || sections.length === 0) return;
    
    // Disconnect existing observer
    if (window.scrollSpyObserver) {
        window.scrollSpyObserver.disconnect();
    }
    
    // Create new Intersection Observer for scroll spy
    window.scrollSpyObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const activeSection = entry.target.getAttribute('data-section');
                    window.updateActiveNavLink(productId, activeSection);
                }
            });
        },
        {
            root: panelBody,
            rootMargin: '-20% 0px -70% 0px',
            threshold: 0
        }
    );
    
    // Observe all sections
    sections.forEach(section => {
        window.scrollSpyObserver.observe(section);
    });
};

window.updateActiveNavLink = function(productId, activeSection) {
    try {
        const drawer = document.getElementById('product-drawer-' + productId);
        if (!drawer || !activeSection) return;
        
        const navLinks = drawer.querySelectorAll('.nav-link');
        
        // Remove active class from all links
        navLinks.forEach(link => link.classList.remove('active'));
        
        // Add active class to corresponding link
        const activeLink = drawer.querySelector(`[data-nav="${activeSection}"]`);
        if (activeLink) {
            activeLink.classList.add('active');
        }
    } catch (error) {
        console.error('Error updating active nav link:', error);
    }
};

// =========================================
// GALLERY FUNCTIONS
// =========================================

// QC D11: hidden gallery slides keep their YouTube embed URL in data-src so the player is only
// downloaded when the slide is shown; leaving a slide blanks the src again so playback stops.
window.oasisSyncLazyFrames = function(slide, isActive) {
    if (!slide || typeof slide.querySelectorAll !== 'function') return;
    slide.querySelectorAll('iframe[data-src]').forEach(function(frame) {
        var lazySrc = frame.getAttribute('data-src');
        if (!lazySrc) return;
        if (isActive) {
            if (frame.getAttribute('src') !== lazySrc) frame.setAttribute('src', lazySrc);
        } else if (frame.getAttribute('src')) {
            frame.setAttribute('src', '');
        }
    });
};

window.moveSlide = function(productId, direction) {
    const gallery = document.getElementById('gallery-' + productId);
    if (!gallery) return;
    
    const slides = Array.from(gallery.querySelectorAll('.gallery-slide'));
    if (slides.length < 2) return;

    const activeSlide = gallery.querySelector('.gallery-slide.active') || slides[0];
    let currentIndex = slides.indexOf(activeSlide);
    if (currentIndex < 0) currentIndex = 0;
    
    // Calculate new index
    let newIndex = currentIndex + direction;
    
    // Loop around
    if (newIndex >= slides.length) {
        newIndex = 0;
    } else if (newIndex < 0) {
        newIndex = slides.length - 1;
    }
    
    // Update slides
    if (activeSlide) {
        activeSlide.classList.remove('active');
        window.oasisSyncLazyFrames(activeSlide, false);
    }
    if (slides[newIndex]) {
        slides[newIndex].classList.add('active');
        window.oasisSyncLazyFrames(slides[newIndex], true);
    }
};

window.initDrawerGallery = function(productId) {
    try {
        const drawer = document.getElementById('product-drawer-' + productId);
        if (!drawer) return;
        
        // Initialize any gallery carousels within the drawer
        const galleries = drawer.querySelectorAll('.gallery-carousel');
        galleries.forEach(gallery => {
            // Add gallery initialization logic here if needed
            // For now, just ensure it's ready
        });
    } catch (error) {
        console.error('Error initializing drawer gallery:', error);
    }
};

// =========================================
// COMPARISON SLIDER
// =========================================

window.initComparisonSlider = function(sliderElement) {
    if (!sliderElement) return;
    const handle = sliderElement.querySelector('.card-slider-handle');
    const beforeImage = sliderElement.querySelector('.before');
    let isSliding = false;
    let startX = 0;
    let startY = 0;
    let touchId = null;

    function startSlide(e) {
        // For touch events, only prevent if it's a horizontal drag
        if (e.touches) {
            touchId = e.touches[0].identifier;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            // Don't prevent default yet - wait to see if it's horizontal
        } else {
            // Mouse events - always allow
            e.preventDefault();
            isSliding = true;
            document.body.style.userSelect = 'none';
        }
    }
    
    function endSlide(e) {
        // Check if this is the same touch
        if (e.changedTouches && touchId !== null) {
            const touch = Array.from(e.changedTouches).find(t => t.identifier === touchId);
            if (!touch) return;
        }
        
        isSliding = false;
        touchId = null;
        document.body.style.userSelect = '';
    }
    
    function onSlide(e) {
        if (e.touches && touchId !== null) {
            const touch = Array.from(e.touches).find(t => t.identifier === touchId);
            if (!touch) return;
            
            const deltaX = Math.abs(touch.clientX - startX);
            const deltaY = Math.abs(touch.clientY - startY);
            
            // Only start sliding if horizontal movement is greater than vertical
            if (!isSliding && deltaX > 10 && deltaX > deltaY) {
                isSliding = true;
                e.preventDefault(); // Only prevent after confirming horizontal drag
            }
            
            if (!isSliding) return; // Still allow vertical scrolling
            
            let pos = touch.clientX;
            let sliderRect = sliderElement.getBoundingClientRect();
            let newWidth = pos - sliderRect.left;
            if (newWidth < 0) newWidth = 0;
            if (newWidth > sliderElement.offsetWidth) newWidth = sliderElement.offsetWidth;
            beforeImage.style.width = newWidth + 'px';
            handle.style.left = newWidth + 'px';
        } else if (!e.touches && isSliding) {
            // Mouse event
            let pos = e.clientX;
            let sliderRect = sliderElement.getBoundingClientRect();
            let newWidth = pos - sliderRect.left;
            if (newWidth < 0) newWidth = 0;
            if (newWidth > sliderElement.offsetWidth) newWidth = sliderElement.offsetWidth;
            beforeImage.style.width = newWidth + 'px';
            handle.style.left = newWidth + 'px';
        }
    }

    sliderElement.addEventListener('mousedown', startSlide);
    document.addEventListener('mouseup', endSlide);
    document.addEventListener('mouseleave', endSlide);
    document.addEventListener('mousemove', onSlide);
    
    // Use passive: true for touchstart to allow scrolling, then check in touchmove
    sliderElement.addEventListener('touchstart', startSlide, { passive: true });
    document.addEventListener('touchend', endSlide, { passive: true });
    document.addEventListener('touchcancel', endSlide, { passive: true });
    document.addEventListener('touchmove', onSlide, { passive: false });
};

// =========================================
// MODAL MANAGEMENT FUNCTIONS
// =========================================

window.openDevModal = function() { 
    const modal = document.getElementById('devModal');
    if (modal) {
        modal.style.display = 'flex'; 
        // Only lock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = 'hidden';
        }
    }
};

window.closeDevModal = function() {
    const modal = document.getElementById('devModal');
    if (modal) {
        modal.style.display = 'none'; 
        // Only unlock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = '';
        }
    }
};
window.openIslandModal = function(productId) { 
    // If called without productId, fall back to old single modal (for product page, etc.)
    var modalId = productId ? 'islandModal-' + productId : 'islandModal';
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.style.display = 'flex'; 
        // Only lock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = 'hidden';
        }
    } else {
        console.error('Island modal not found for id:', modalId);
    }
};

window.closeIslandModal = function(productId) {
    var modalId = productId ? 'islandModal-' + productId : 'islandModal';
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.style.display = 'none'; 
        // Only unlock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = '';
        }
    }
};


window.openEverythingModal = function() { 
    const modal = document.getElementById('everythingModal');
    if (modal) {
        modal.style.display = 'flex'; 
        // Only lock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = 'hidden';
        }
    }
};

window.closeEverythingModal = function() {
    const modal = document.getElementById('everythingModal');
    if (modal) {
        modal.style.display = 'none'; 
        // Only unlock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = '';
        }
    }
};

window.openFloorPlanModal = function(buttonElement) { 
    const modal = document.getElementById('floorPlanModal');
    const title = document.getElementById('fp-title');
    const img   = document.getElementById('fp-image');
    const text  = document.getElementById('fp-text');

    if (!modal || !title) return;

    const planTitle = buttonElement.getAttribute('data-plan-title') || 'Floor Plans';
    const planText  = buttonElement.getAttribute('data-plan-text') || '';
    const planImage = buttonElement.getAttribute('data-plan-floorplan-image') || '';

    // Set modal title
    title.innerText = planTitle + ' Floor Plans';

    // Set image
    if (img) {
        if (planImage) {
            img.src = planImage;
            img.alt = planTitle + ' floor plan';
            img.style.display = 'block';
        } else {
            img.src = '';
            img.style.display = 'none';
        }
    }

    // Set description text
    if (text) {
        // because description was escaped in data attribute, use textContent
        text.textContent = planText;
    }

    modal.style.display = 'flex';
    // Only lock scroll on mobile devices
    if (window.isMobileDevice()) {
        document.body.style.overflow = 'hidden';
    }
};


window.closeFloorPlanModal = function() {
    const modal = document.getElementById('floorPlanModal');
    if (modal) {
        modal.style.display = 'none'; 
        // Only unlock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = '';
        }
    }
};


window.openSpecInfo = function(element) {
    const modal = document.getElementById('specInfoModal');
    const title = document.getElementById('info-modal-title');
    const content = document.getElementById('spec-info-content');

    if (!modal || !title || !content) return;

    const label = element.getAttribute('data-label');
    const infoContent = element.getAttribute('data-info');

    title.innerText = label; // 👈 Now dynamic from schema

    content.innerHTML = `
        <p style="line-height:1.6; font-size:1rem;">
            ${infoContent}
        </p>
    `;

    modal.style.display = 'flex';

    if (window.isMobileDevice && window.isMobileDevice()) {
        document.body.style.overflow = 'hidden';
    }
};


window.closeSpecInfo = function() {
    const modal = document.getElementById('specInfoModal');
    if (modal) {
        modal.style.display = 'none';
        // Only unlock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = '';
        }
    }
};

window.openRefundInfo = function() {
    const modal = document.getElementById('specInfoModal');
    const title = document.getElementById('info-modal-title');
    const content = document.getElementById('spec-info-content');
    
    if (!modal || !title || !content) return;
    
    title.innerText = 'Reservation Information';
    content.innerHTML = `<p style="line-height:1.6; font-size:1rem;">The $250 reservation fee is <strong>fully refundable</strong> within 10 days. We will send you all legal documents for review immediately after reservation to help your due diligence process.</p>`;
    modal.style.display = 'flex';
    // Only lock scroll on mobile devices
    if (window.isMobileDevice()) {
        document.body.style.overflow = 'hidden';
    }
};

window.openIncludedInfo = function(triggerEl, productId) {
  const modal   = document.getElementById('included-info-modal-' + productId);
  const titleEl = document.getElementById('included-info-title-' + productId);
  const content = document.getElementById('included-info-content-' + productId);

  if (!modal || !titleEl || !content) return;

  const benefitCard = triggerEl.closest('.benefit-card');
  if (!benefitCard) return;

  const benefitTitleEl = benefitCard.querySelector('.benefit-text strong');
  const popupText = benefitCard.getAttribute('data-popup') || '';

  if (benefitTitleEl) {
    titleEl.innerText = benefitTitleEl.innerText + ' Details';
  }

  content.innerHTML = `<p style="line-height:1.6; font-size:1rem;">${popupText}</p>`;

  modal.style.display = 'flex';
  // Only lock scroll on mobile devices
  if (window.isMobileDevice()) {
      document.body.style.overflow = 'hidden';
  }
};

window.closeIncludedInfo = function(productId) {
    const modal = document.getElementById('included-info-modal-' + productId);
    if (modal) {
        modal.style.display = 'none';
        // Only unlock scroll on mobile devices
        if (window.isMobileDevice()) {
            document.body.style.overflow = '';
        }
    }
};

// =========================================
// INITIALIZATION - MOBILE OPTIMIZED
// =========================================

// CRITICAL: Define all essential functions FIRST before any initialization
// This ensures they're available immediately when onclick handlers fire

// Mobile device detection - MUST be defined early
if (typeof window.isMobileDevice !== 'function') {
    window.isMobileDevice = function() {
        return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
}

// Initialize modal references immediately - CRITICAL for immediate clickability
(function initModalReferences() {
    // Try to get modals immediately
    window.videoModal = document.getElementById('videoModal');
    window.paymentCalcModal = document.getElementById('paymentCalcModal');
    
    // If DOM not ready, also set up listener for when it is
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            if (!window.videoModal) window.videoModal = document.getElementById('videoModal');
            if (!window.paymentCalcModal) window.paymentCalcModal = document.getElementById('paymentCalcModal');
        });
    } else {
        // DOM already ready - ensure modals are set
        if (!window.videoModal) window.videoModal = document.getElementById('videoModal');
        if (!window.paymentCalcModal) window.paymentCalcModal = document.getElementById('paymentCalcModal');
    }
})();

// Prevent double initialization - DEFER ALL HEAVY OPERATIONS to avoid blocking
(function initProductCard() {
    if (window._productCardInitialized) return;
    window._productCardInitialized = true;
    
    // CRITICAL: Defer all heavy operations to prevent blocking the main thread
    function doInit() {
        // Initialize modal references (already done above, but ensure they're set)
        // This is lightweight, can run immediately
        if (!window.videoModal) window.videoModal = document.getElementById('videoModal');
        if (!window.paymentCalcModal) window.paymentCalcModal = document.getElementById('paymentCalcModal');
        
        // DEFER: Initialize comparison sliders - use requestIdleCallback to avoid blocking
        if (!window._slidersInitialized) {
            window._slidersInitialized = true;
            const initSliders = () => {
                document.querySelectorAll('.card-slider-container').forEach(slider => {
                    if (!slider._sliderInitialized) {
                        slider._sliderInitialized = true;
                        if (window.initComparisonSlider) {
                            window.initComparisonSlider(slider);
                        }
                    }
                });
            };
            
            // Use requestIdleCallback with optimized timeout for mobile
            // Shorter timeout on mobile for faster initialization
            const isMobile = window.isMobileDevice && window.isMobileDevice();
            const timeout = isMobile ? 1000 : 2000;
            
            if (window.requestIdleCallback) {
                requestIdleCallback(initSliders, { timeout: timeout });
            } else {
                setTimeout(initSliders, isMobile ? 50 : 100);
            }
        }

        // DEFER: Event listeners for modal backdrops - defer to avoid blocking
        if (!window._modalListenersAdded) {
            window._modalListenersAdded = true;
            const initModalListeners = () => {
                const modals = [
                    'videoModal', 'paymentCalcModal', 'calcModal', 'devModal', 
                    'islandModal', 'everythingModal', 'specInfoModal', 'floorPlanModal'
                ];
                
                modals.forEach(modalId => {
                    const modal = document.getElementById(modalId);
                    if (modal && !modal._backdropListenerAdded) {
                        modal._backdropListenerAdded = true;
                        modal.addEventListener('click', function(e) {
                            if (e.target === modal) {
                                modal.style.display = 'none';
                                // Only unlock scroll on mobile devices
                                if (window.isMobileDevice && window.isMobileDevice()) {
                                    document.body.style.overflow = '';
                                }
                            }
                        });
                    }
                });

                // ESC key to close modals and drawers (only once)
                if (!window._escapeKeyListenerAdded) {
                    window._escapeKeyListenerAdded = true;
                    document.addEventListener('keydown', function(event) {
                        if (event.key === 'Escape') {
                            // Close modals
                            modals.forEach(modalId => {
                                const modal = document.getElementById(modalId);
                                if (modal && modal.style.display === 'flex') {
                                    modal.style.display = 'none';
                                    // Only unlock scroll on mobile devices
                                    if (window.isMobileDevice && window.isMobileDevice()) {
                                        document.body.style.overflow = '';
                                    }
                                }
                            });
                            
                            // Close any open drawer
                            if (window.currentOpenDrawerId && window.closeDrawer) {
                                window.closeDrawer(window.currentOpenDrawerId);
                            }
                        }
                    });
                }
                
                window.OasisDebug && console.log('✅ All modals and drawers initialized successfully');
            };
            
            // Defer modal listener initialization
            if (window.requestIdleCallback) {
                requestIdleCallback(initModalListeners, { timeout: 1500 });
            } else {
                setTimeout(initModalListeners, 50);
            }
        }
    }
    
    // CRITICAL: Always defer doInit to next tick to avoid blocking
    // Use requestAnimationFrame for better mobile performance
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            // Defer even after DOMContentLoaded to avoid blocking
            // Use requestAnimationFrame for smoother mobile experience
            requestAnimationFrame(function() {
                setTimeout(doInit, 0);
            });
        });
    } else {
        // DOM already loaded - still defer to avoid blocking
        // Use requestAnimationFrame for smoother mobile experience
        requestAnimationFrame(function() {
            setTimeout(doInit, 0);
        });
    }
})();

// =========================================
// UTILITY FUNCTIONS
// =========================================

window.toggleDesc = function() {
    const moreText = document.getElementById('desc-more');
    const btn = document.getElementById('read-more-btn');
    if (!moreText || !btn) return;
    
    if(moreText.style.display === "inline") {
        moreText.style.display = "none";
        btn.innerHTML = "Read more";
    } else {
        moreText.style.display = "inline";
        btn.innerHTML = "Read less";
    }
};

// Safe function check for HTML onclick attributes
window.safeFunctionCall = function(fnName, ...args) {
    if (typeof window[fnName] === 'function') {
        window[fnName](...args);
    } else {
        console.error(`Function ${fnName} not found`);
    }
};

// Read more functionality for land descriptions - DEFER to avoid blocking
// Use event delegation for better mobile performance
(function initLandDesc() {
    if (window._landDescInitialized) return;
    window._landDescInitialized = true;
    
    function doInit() {
        // Use event delegation for better performance on mobile - works immediately
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('.land-desc-toggle');
            if (!btn) return;
            
            var targetId = btn.getAttribute('data-target');
            var container = document.getElementById(targetId);
            if (!container) return;

            container.classList.toggle('expanded');

            if (container.classList.contains('expanded')) {
                var btnText = btn.querySelector('.toggle-text') || btn;
                if (btnText) btnText.textContent = 'Read less';
            } else {
                var btnText = btn.querySelector('.toggle-text') || btn;
                if (btnText) btnText.textContent = 'Read more';
            }
        });
    }
    
    // CRITICAL: Initialize immediately using event delegation - no DOM wait needed
    // Event delegation works even before DOM is fully loaded
    doInit();
})();

// Terms and conditions toggle - SINGLE INSTANCE
// Use event delegation - works immediately, no DOMContentLoaded needed
(function initTermsToggle() {
    if (window._termsListenerAdded) return;
    window._termsListenerAdded = true;
    
    // Event delegation works immediately - no need to wait for DOMContentLoaded
    document.addEventListener('click', function (event) {
        const termsButton = event.target.closest('[data-terms-button]');
        if (!termsButton) return;

        const container = termsButton.closest('[data-terms-container]');
        if (!container) return;

        const content = container.querySelector('[data-terms-content]');
        const icon = container.querySelector('[data-terms-icon]');

        if (!content) return;

        content.classList.toggle('hidden');

        if (icon) {
            icon.classList.toggle('rotate-180');
        }
    });
})();

// Debug function
window.debugPaymentStates = function() {
    window.OasisDebug && console.log('🔍 Current Payment States:', window.paymentStates);
    const currentProductId = window.paymentCalcModal?.dataset.currentProductId;
    window.OasisDebug && console.log('📋 Modal current product:', currentProductId);
};

// Book-a-Call buttons are handled by the market-aware global modal listener.
